import { useTranslation } from "react-i18next";
import { AI_TOP_MATCHES_STAGES, getRunProgress } from "@/hooks/jobs/useAITopMatches";
import type { AITopMatchesRun } from "@/hooks/jobs/useAITopMatches";
import { AITopMatchesIcon } from "./AITopMatchesIcon";

interface AITopMatchesBackgroundProgressProps {
	run: AITopMatchesRun;
	onOpen: () => void;
}

/** Progress strip shown while a search runs and its pop-up is closed. */
export function AITopMatchesBackgroundProgress({ run, onOpen }: AITopMatchesBackgroundProgressProps) {
	const { t } = useTranslation();
	const { currentIndex, overall } = getRunProgress(run);
	const stage = AI_TOP_MATCHES_STAGES[Math.max(0, currentIndex)];

	return (
		<div className="mb-4 w-full p-3">
			<div className="mb-2 flex items-center gap-2">
				<AITopMatchesIcon working className="h-4 w-4 text-purple-600" />
				<p className="flex-1 text-xs font-medium text-purple-900 dark:text-purple-200">
					{t("aiTopMatches.background.title")} · {t(`aiTopMatches.stages.${stage}`)}
				</p>
				<button type="button" onClick={onOpen} className="text-xs font-medium text-purple-700 hover:underline dark:text-purple-300">
					{t("aiTopMatches.background.view")}
				</button>
			</div>
			<div className="h-1 w-full overflow-hidden rounded-sm bg-purple-100 dark:bg-purple-950/50">
				<div className="h-1 rounded-sm bg-purple-500 transition-all duration-1000 ease-out" style={{ width: `${overall}%` }} />
			</div>
			<div className="mt-1 flex justify-between text-xs text-purple-500 opacity-75">
				<span>{overall}%</span>
				<span>{t("common.processing", "Processing...")}</span>
			</div>
		</div>
	);
}
